import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SD = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M2.844 6.416a3.25 3.25 0 0 1 3.25-3.25h12a3.25 3.25 0 0 1 3.25 3.25v12a3.25 3.25 0 0 1-3.25 3.25h-12a3.25 3.25 0 0 1-3.25-3.25z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M8.612 15.916q-.582 0-1.164-.135a3.4 3.4 0 0 1-1.01-.395.62.62 0 0 1-.318-.385.77.77 0 0 1 .027-.481.58.58 0 0 1 .291-.327q.2-.097.482.048.365.22.81.327.445.106.882.106.655 0 .937-.212.29-.22.29-.549a.54.54 0 0 0-.2-.443q-.2-.163-.7-.279l-1.027-.231q-1.72-.385-1.72-1.887 0-.645.328-1.127a2.15 2.15 0 0 1 .91-.76q.59-.27 1.364-.27.51 0 1 .135.49.124.864.375a.6.6 0 0 1 .282.376.7.7 0 0 1-.036.443.5.5 0 0 1-.291.298q-.2.087-.5-.067-.3-.165-.637-.24a3 3 0 0 0-.691-.078q-.573 0-.892.24a.72.72 0 0 0-.309.607q0 .28.191.453t.664.28l1.028.23q1.764.405 1.764 1.83 0 .635-.327 1.117a2.13 2.13 0 0 1-.91.741q-.582.26-1.382.26'
          fill='currentColor'
        />
        <path
          d='M12.883 15.81q-.737 0-.737-.78V9.802q0-.78.737-.78h1.773q1.637 0 2.537.886.9.876.9 2.503t-.9 2.513-2.537.886zm.673-1.223h1.018q2.047 0 2.047-2.176 0-2.166-2.047-2.166h-1.018z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.094 2.416a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm1.354 13.365q.582.135 1.164.135.8 0 1.382-.26a2.13 2.13 0 0 0 .91-.741q.327-.482.327-1.117 0-1.425-1.764-1.83l-1.028-.23q-.473-.107-.664-.28a.58.58 0 0 1-.19-.453q0-.375.308-.606.32-.24.892-.24.354 0 .69.076.337.078.637.24.3.155.5.068a.5.5 0 0 0 .292-.298.7.7 0 0 0 .036-.443.6.6 0 0 0-.282-.376 2.8 2.8 0 0 0-.864-.375 3.8 3.8 0 0 0-1-.135q-.774 0-1.364.27a2.15 2.15 0 0 0-.91.76q-.327.482-.327 1.127 0 1.502 1.719 1.887l1.027.231q.5.115.7.28.2.162.2.442 0 .328-.29.55-.282.21-.937.21-.437 0-.882-.105a2.8 2.8 0 0 1-.81-.327q-.281-.145-.482-.048a.58.58 0 0 0-.29.327.77.77 0 0 0-.028.481q.064.241.318.385.428.26 1.01.395m4.698-.75q0 .78.737.78h1.773q1.637 0 2.537-.887.9-.885.9-2.513t-.9-2.503q-.9-.886-2.537-.886h-1.773q-.737 0-.737.78zm2.428-.444h-1.018v-4.342h1.018q2.047 0 2.047 2.166 0 2.176-2.047 2.176'
        fill='currentColor'
      />
    )}
  </IconBase>
);
